import React, { FC } from 'react';
import { Formik, Field } from 'formik';
import {
  Modal,
  Content,
  IconWrapper,
  GiftIcon,
  Title,
  Text,
  SuccessText,
  Button,
  Form,
  Row,
  Input,
  CheckIcon,
} from './styles';
import { Props } from './types';
import useConnect from './connect';

const ModalReferral: FC<Props> = ({ handleClose }) => {
  const { handleSubmit, initialValues, validationSchema, showModal } =
    useConnect();

  return (
    <Modal open handleClose={handleClose}>
      {!showModal ? (
        <>
          <Content>
            <IconWrapper>
              <GiftIcon />
            </IconWrapper>
            <Title>Refer & Earn $100</Title>
            <Text>Each referral that launches will earn you $100!</Text>
          </Content>
          <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
          >
            <Form noValidate>
              <Row>
                <Field
                  name="name"
                  as={Input}
                  label="Owner name"
                  placeholder="Add name"
                />
                <Field
                  name="restaurantName"
                  as={Input}
                  label="Owner restaurant"
                  placeholder="Add name"
                />
              </Row>
              <Row>
                <Field
                  name="city"
                  as={Input}
                  label="City"
                  placeholder="Add city name"
                />
              </Row>
              <Row>
                <Field
                  name="phoneNumber"
                  as={Input}
                  label="Owner phone number"
                  placeholder="Add phone number"
                />
                <Field
                  name="email"
                  as={Input}
                  label="Owner email"
                  placeholder="Add email"
                />
              </Row>

              <Button type="submit">Refer</Button>
            </Form>
          </Formik>
        </>
      ) : (
        <>
          <Content>
            <IconWrapper>
              <CheckIcon />
            </IconWrapper>
            <Title>Referral Submitted</Title>
            <SuccessText>
              Once your referrals start with Superorder, you will receive $100!
            </SuccessText>
            <Button color="primary" variant="floating" onClick={handleClose}>
              Close
            </Button>
          </Content>
        </>
      )}
    </Modal>
  );
};

export default ModalReferral;
